import { useFormHasBeenSent } from '@tectonics/prs/form-status';
import { useSubmitting } from '@tectonics/prs/submitting';
import { useSubmitError, useUserInputValidationError } from '@tectonics/prs/validation';
import type { UserInputValidationError } from '@tectonics/prs/validation';

interface FormFeedback {
  readonly submitting: boolean;
  readonly validationError: UserInputValidationError | null;
  readonly formHasBeenSent: boolean;
  readonly submitFailed: boolean;
}

function useFormFeedback(fieldId: string): FormFeedback {
  const validationError = useUserInputValidationError(fieldId);
  const formHasBeenSent = useFormHasBeenSent();
  const submitting = useSubmitting();
  const submitFailed = useSubmitError() != null;

  return { submitting, validationError, formHasBeenSent, submitFailed };
}

export { useFormFeedback };
